
import VaultDialog from '../components/vault-dialog';
import VaultEmailDialog from '../components/vault-email-dialog';

(function () {

  function ready() {

    var vaultTicketModal = $('#vault-ticket-modal');
    var vaultEmailModal = $('#vault-email-modal');

    if (vaultTicketModal.length || vaultEmailModal.length) {
      $('.vault-actions .ux-spinner').hide();
    }

    if (vaultTicketModal.length) {

      var vaultTicketOptions = {
        title: 'Send Feedback to Writers',
        contentSelector: '#ticket-dialog',
        initFunction: window.gdvault.showFeedbackDialog,
        openButtonLabel: 'Feedback',
        continueFunction: window.gdvault.sendFeedback,
        continueButtonLabel: 'Create',
        closeButtonLabel: 'Cancel'
      };

      ReactDOM.render(React.createElement(VaultDialog, vaultTicketOptions),
        vaultTicketModal[0]);
    }

    if (vaultEmailModal.length && window.gdvault.vaultEmail) {
      var props = window.gdvault.vaultEmail;

      props.verifyCustomerNumber = window.gdvault.verifyCustomerNumber;
      props.sendEmail = window.gdvault.sendEmail;

      ReactDOM.render(React.createElement(VaultEmailDialog, props),
        vaultEmailModal[0]);
    }

  }

  $(document).ready(ready);

}());
